import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import SalesStaticTableCell from './SalesStaticTableCell';

/**
 * 영역별 본문 배경색 정의 (OrderStaticTableCell과 동기화)
 */
const forecastBodyColors = {
  STAT: '#f1f8fe', // 수주 (Blue)
  OA: '#f1f8fe', // 수주 (Blue)
  HM: '#fff9f2', // 포캐스팅 (Orange)
  ES: '#f1faf2', // 예상실적 (Green)
};

const SalesStaticsHeadquerterRows = ({ data, headerRows, selectPrjTyp, useKorean }) => {
  // 데이터가 없을 때 TableRow 형식을 유지하여 에러 방지
  if (!data || (Array.isArray(data) && data.length === 0)) {
    return null; 
  }

  return (
    data.map((hq, hIndex) => {
      const isTotalRow = hq.id === 'total' && hq.name.includes('합계');
      const rowBgColor = isTotalRow ? '#f5f5f5' : 'inherit';
      const bottomBorder = isTotalRow ? '1px solid #aaa' : '1px solid #f0f0f0';

      return (
        <TableRow 
          key={hIndex}
          sx={{ 
            backgroundColor: rowBgColor,
            '& .MuiTableCell-root': {
              borderBottom: bottomBorder
            }
          }}
        >
          <TableCell 
            align="center" 
            sx={{ 
              width: '120px', 
              fontWeight: hq.id === 'total' ? 'bold' : 'normal',
              bgcolor: isTotalRow ? '#edf2f7' : hq.id === 'total' ? '#f5f5f5' : 'inherit',
              borderRight: '1px solid #eee'
            }}
          >
            {hq.name}
          </TableCell>

          <SalesStaticTableCell
            useKorean={useKorean}
            selectPrjTyp={selectPrjTyp} 
            data={hq} 
            headerRows={headerRows} 
            bodyColors={forecastBodyColors} // 세로 색상 기둥 전달
            isTotalRow={isTotalRow}          // 소계 강조 여부 전달
          />
        </TableRow>
      );
    })
  );
};

export default SalesStaticsHeadquerterRows;
